import React from "react";
import clsx from "clsx";
import "@/css/redirecting.css";

const LoadingIndicator = ({ centered, className, style }) => {
  return (
    <div
      className={clsx("loading-wrapper", centered && "centered", className)}
      style={style}
    >
      <div className="loadingio-spinner-ellipsis-0e9htm6lpb7">
        <div className="ldio-tk8dyrglbc">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingIndicator;
